import React, { useEffect, useState } from 'react';
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { setLocationData, fetchImageRequest, updateModal } from '../../../store/actions/location';
import { useDispatch, useSelector } from 'react-redux';
import { Switch } from 'antd';
import { fetchRequest, updateFilters } from '../../../store/actions/devices';
import { fetchProfileRequest } from '../../../store/actions/shipment';
import { getRandomId } from '../../../global/utility/Utils';
import FloorImageComponent from './floorImageComponent';
import { DropDown } from '../wrapperComponents/DropDown';
import { Input } from "@vds/inputs"
import { ErrorMessage } from "../../../global/components/ValidationIcon";

export const ZoneFormContent = () => {
    const dispatch = useDispatch();
    const location_data = useSelector((state) => state.location.location_data || []);
    const [selectedFile, setSelectedFile] = React.useState(null);
    const { filters: filtersCopy } = useSelector((state) => state.devices);
    const gatewayList = useSelector((state) => state.devices.data.devices || []);
    const deviceProfiles = useSelector((state) => state.shipment.data.shipProfile || []);
    const [zoneId, setZoneId] = useState(null);
    const errors = useSelector((state) => state.location.location_data.zoneErrors || {});
    let shouldAddGatewayEnabled = true;
    const zone_id_selected_for_file = location_data?.newZones?.[selectedFile?.id]?.zone_id_selected;
    const zone_name_for_file = location_data?.floors?.[selectedFile?.id]?.zones?.[zone_id_selected_for_file]?.zone_name;
    const zone_coord_for_file = location_data?.floors?.[selectedFile?.id]?.zones?.[zone_id_selected_for_file]?.zone_coordinates;

    if(zone_name_for_file?.length > 0 && zone_coord_for_file?.length >= 3) {
        shouldAddGatewayEnabled = false;
    }

    useEffect(() => {
        if(!selectedFile) return;
        const tempZone = `${selectedFile?.id}_${getRandomId('zone')}`;
        const zoneid = location_data?.newZones?.[selectedFile?.id]?.zoneAlreadySelected == true ?
            location_data?.newZones?.[selectedFile?.id]?.zone_id_selected :
                tempZone;
        if (!(location_data?.newZones?.[selectedFile?.id]?.zoneAlreadySelected == true)) {
            setTimeout(()=>dispatch(setLocationData({ ...location_data, selectedFile: selectedFile, newZones: { ...location_data?.newZones, [selectedFile?.id]: { ...location_data?.newZones?.[selectedFile?.id], newlyAddedZone: true, zoneAlreadySelected: true, zone_id_selected: tempZone } } })),0);
        } else {
            dispatch(setLocationData({ ...location_data, selectedFile: selectedFile }))
        }
        const decided_zone = (location_data?.action_type == 'edit' || location_data?.backButtonClicked) && location_data?.newZones?.[selectedFile?.id]?.zoneAlreadySelected ? location_data?.newZones?.[selectedFile?.id]?.zone_id_selected : zoneid
        setZoneId(decided_zone)
    }, [selectedFile]);

    useEffect(() => { 
        setZoneId(location_data?.newZones?.[selectedFile?.id]?.zone_id_selected);
    }, [location_data?.newZones?.[selectedFile?.id]?.zone_id_selected])

    // Optimized custom hook to get zone field values using useCallback
    const getZoneFieldValues = React.useCallback(
        (field_name) => {
            return location_data?.floors?.[selectedFile?.id]?.zones?.[zoneId]?.[field_name];
        },
        [location_data, selectedFile, zoneId]
    );


    const gatewayProfileTemp = deviceProfiles
        .filter(profile => profile.devicetype === (getZoneFieldValues('devicetype')) && profile.profiletype === 'nonshipment')
        .map(profile => ({
            profileid: profile.profileid,
            profilename: profile.profilename,
            profiletype: profile.profiletype,
        }));

    useEffect(() => {
        if (location_data?.selectedFloorKey) {
            setSelectedFile({ id: location_data?.selectedFloorKey, ...location_data?.floors[location_data?.selectedFloorKey] })
        }
        if (location_data?.action_type == 'edit' && location_data?.editNewFloorUpdated) {
            setSelectedFile({ id: location_data?.editNewFloorUpdatedId, ...location_data?.floors[location_data?.editNewFloorUpdatedId] });
        }
    }, [location_data?.selectedFloorKey, location_data?.editNewFloorUpdated]);
    const updateZone = (data) => {
        dispatch(setLocationData({
            ...location_data,
            floors: {
                ...location_data.floors,
                [selectedFile?.id]: {
                    ...location_data.floors[selectedFile?.id],
                    zones: {
                        ...location_data.floors[selectedFile?.id]?.zones,
                        [zoneId]: {
                            ...location_data.floors[selectedFile?.id]?.zones?.[zoneId],
                            id: zoneId,
                            ...data
                        }
                    }
                }
            }
        }
        ))
    }

    useEffect(() => {
        const imageRequests = Object.values(location_data?.floors).filter((floor) => !(floor?.file instanceof Blob)).map((floor) => {
            return { imageId: floor?.floorImageId, floorKey: floor?.id };
        });
        imageRequests?.length > 0 && dispatch(fetchImageRequest(imageRequests));
    }, [location_data?.floors]);

    const handleZoneNameChange = (e) => {
        if (location_data?.action_type == 'edit' && location_data?.newZones?.[selectedFile?.id]?.zoneAlreadySelected) {
            dispatch(setLocationData({
                ...location_data,
                floors: {
                    ...location_data.floors,
                    [selectedFile?.id]: {
                        ...location_data.floors[selectedFile?.id],
                        zones: {
                            ...location_data.floors[selectedFile?.id]?.zones,
                            [zoneId]: {
                                ...location_data.floors[selectedFile?.id]?.zones?.[zoneId],
                                zone_name: e.target.value
                            }
                        }
                    }
                }
            }))
        } else {
            updateZone({ zone_name: e.target.value })
        }
    }

    useEffect(() => {
        if(!selectedFile?.id || !zoneId) return;
        if (location_data?.floors[selectedFile?.id]?.zones?.[zoneId]?.addgateway === true ) {
            const { limitnumber, pagenumber, ...restFilters } = filtersCopy;
            dispatch(fetchRequest({ ...restFilters, deviceType: ['AssetTracker'], isAvailable: true })); // Fetch only available gateways, assetTrackers assures that gateways are filtered from devices
            dispatch(updateFilters({ ...filtersCopy })); // Update filters in store
        } else {
            const gatewayAttributeRemovedZone = {
                id: location_data?.floors[selectedFile?.id]?.zones?.[zoneId]?.id,
                zone_name: location_data?.floors[selectedFile?.id]?.zones?.[zoneId]?.zone_name,
                zone_coordinates: location_data?.floors[selectedFile?.id]?.zones?.[zoneId]?.zone_coordinates,
                addgateway: false
            };
            dispatch(setLocationData({
                ...location_data,
                floors: {
                    ...location_data.floors,
                    [selectedFile?.id]: {
                        ...location_data.floors[selectedFile?.id],
                        zones: {
                            ...location_data.floors[selectedFile?.id]?.zones,
                            [zoneId]: {
                                ...gatewayAttributeRemovedZone
                            }
                        }
                    }
                }
            }));
        }
    }, [location_data?.floors[selectedFile?.id]?.zones?.[zoneId]?.addgateway]);

    const gateway_id = location_data?.floors[selectedFile?.id]?.zones?.[zoneId]?.devicetype;

    useEffect(() => {
        if (location_data?.floors[selectedFile?.id]?.zones?.[zoneId]?.addgateway === true) {
            if (getZoneFieldValues('devicetype')) {
                //get deviceProfile using deviceType
                dispatch(fetchProfileRequest({ selection: `(devicetype eq '${getZoneFieldValues('devicetype')}') AND (profiletype eq 'nonshipment')` }));
            }
        }
    }, [gateway_id]);

return <>
        <div style={{ marginBottom: "5px", marginTop: "5px" }}>
        {location_data?.action_type !== 'edit' ? <p className={"inventory-location-popup-title"}>
            Add Location
        </p> : location_data?.editNewFloorUpdated ? <p className={"inventory-location-popup-title"}>
            Edit Location
        </p> : null}

            <h2 className={"font-face-vzb page-header-location"} style={{ marginBottom: '18px' }}>
                {location_data?.action_type !== 'edit' ? 'Add zone' : location_data?.editNewFloorUpdated? 'Add zone' : 'Edit Location'}
            </h2>
            <Grid2
                container
                marginTop={1}
                marginBottom={2}
                spacing={1}
                columns={{ xs: 12 }}
            >
                <Grid2 item xs={12} sm={12} md={12} lg={12} direction="row">
                    <DropDown
                        label="Floor name"
                        value={selectedFile?.name}
                        name={"locationNameDropDownFloor"}
                        customClass={'left-3px'}
                        onChangeFn={
                            (value) => { dispatch(setLocationData({ ...location_data, newZoneCoordinates: [] })); setSelectedFile({ id: value, ...location_data?.floors[value] }); }
                        }
                        placeholder={"Select a floor"}
                        error={errors?.initial == true ? false : (errors?.['locationNameDropDownFloor']?.length > 0 ? true : false)}
                        errors={{
                            'locationNameDropDownFloor': errors?.['locationNameDropDownFloor'] !== '' ? errors?.['locationNameDropDownFloor'] : ''
                        }}
                        options={Object.keys(location_data.floors).map((floorKey) => ({ label: location_data.floors[floorKey].name, value: floorKey }))}
                    />
                    <div className='font12Location' style={{ color: '#6F7171', marginTop: '-11px', marginLeft: '2px' }}>
                        Select floor to create zone.
                    </div>
                </Grid2>
                <div style={{ display: 'flex', flexDirection: 'column-reverse', gap: 16, width: '100%' }}>
                    {
                        //selectedFile?.id is floorKey
                    }
                    {selectedFile && <div style={{ marginTop: '6px' }}>
                        <FloorImageComponent floorid={selectedFile?.id} zone_id={zoneId} enableCreateButton={true} />
                        <div style={{ paddingTop: 0 }}>
                            <ErrorMessage
                                fieldName="zoneCoordinates"
                                className={"ats-error-message-imp"}
                                errors={{ 'zoneCoordinates': errors?.['zoneCoordinates'] !== '' ? errors?.['zoneCoordinates'] : '' }}
                            />
                        </div>
                    </div>}
                    {selectedFile && <Grid2 item xs={12} sm={12} md={12} lg={12} direction="row">
                        <div className="mb-1">
                            <label className="input-label-user" style={{ marginLeft: '1px', marginTop: '16px' }}>Zone name</label>
                            <div style={{ marginBottom: '8px !important' }}>
                                <Input
                                    type="text"
                                    id="zoneName"
                                    name="zoneName"
                                    value={location_data?.floors?.[selectedFile?.id]?.zones?.[location_data?.newZones?.[selectedFile?.id]?.zone_id_selected]?.zone_name || ''}
                                    maxLength={30}
                                    required={false}
                                    onChange={(e) => handleZoneNameChange(e)}
                                    placeholder="Enter zone name"
                                    disabled = { (location_data?.action_type == 'edit' && ( !location_data?.addNewZOneButtonClicked || !location_data?.editNewFloorUpdatedId )) && !location_data?.newZones?.[selectedFile?.id]?.zoneAlreadySelected }
                                    error={errors?.initial == true ? false : (errors?.['zoneName']?.length > 0 ? true : false)}
                                />
                                <ErrorMessage className={"ats-error-message-imp margin-8"} fieldName="zoneName" errors={{ 'zoneName': errors?.['zoneName'] !== '' ? errors?.['zoneName'] : '' }} />
                            </div>
                        </div>
                    </Grid2>}
                </div>
                <div
                    className="d-flex flex-row justify-content-start align-items-center"
                    style={{
                        padding: "8px 0px",
                        margin: "4px 0px",
                    }}
                >
                    <div
                        className="font-face-vzw font20Location"
                        style={{
                            fontWeight: 700,
                        }}
                    >
                        Add gateway
                    </div>
                    <div className="px-2">
                        <Switch
                            style={
                                location_data?.floors[selectedFile?.id]?.zones?.[zoneId]?.addgateway === true
                                    ? {
                                        backgroundColor: "#008331",
                                    }
                                    : {
                                        backgroundColor: "#d8dada",
                                    }
                            }
                            checked={location_data?.floors[selectedFile?.id]?.zones?.[zoneId]?.addgateway === true}
                            onChange={(e) => updateZone({ addgateway: e })}
                            disabled={shouldAddGatewayEnabled}
                        />
                    </div>
                    <span
                        style={{
                            color: "#6F7171",
                            marginLeft: "8px",
                        }}
                        className='font12Location'
                    >
                        Required for geofence alert
                    </span>
                </div>
                {
                    location_data?.floors[selectedFile?.id]?.zones?.[zoneId]?.addgateway === true &&
                    <Grid2 container spacing={2} columns={{ xs: 12 }} wrap="nowrap" style={{ width: '100%' }}>
                        <Grid2 item xs={6} style={{ minWidth: 0 }}>
                            <DropDown
                                label="Gateway"
                                value={getZoneFieldValues('gateway_name') || ''}

                                name={"GatewayDropDown"}
                                // customClass={'left-3px'}
                                onChangeFn={
                                    (value) => { updateZone(JSON.parse(value)) }
                                }
                                placeholder="Select Gateway"
                                error={errors?.initial == true ? false : (errors?.['GatewayDropDown']?.length > 0 ? true : false)}
                                errors={{
                                    'GatewayDropDown': errors?.['GatewayDropDown'] !== '' ? errors?.['GatewayDropDown'] : ''
                                }}

                                options={gatewayList.map((gateway) => ({ label: gateway.name, value: JSON.stringify({ gateway_id: gateway.uid, gateway_name: gateway.name, devicetype: gateway.devicetype || '' }) }))}
                            />
                        </Grid2>
                        <Grid2 item xs={6} style={{ minWidth: 0 }}>
                            <DropDown
                                label="Gateway Profile"
                                value={getZoneFieldValues('gateway_profile_name') || ''}

                                name={"GatewayProfileDropDown"}
                                // customClass={'left-3px'}
                                onChangeFn={
                                    (value) => { updateZone(JSON.parse(value)) }
                                }
                                placeholder="Select Gateway Profile"
                                error={errors?.initial == true ? false : (errors?.['GatewayProfileDropDown']?.length > 0 ? true : false)}
                                errors={{
                                    'GatewayProfileDropDown': errors?.['GatewayProfileDropDown'] !== '' ? errors?.['GatewayProfileDropDown'] : ''
                                }}
                                options={gatewayProfileTemp.map((profile) => ({ label: profile.profilename, value: JSON.stringify({ gateway_profile_id: profile.profileid, gateway_profile_name: profile.profilename }) }))}
                            />
                        </Grid2>
                    </Grid2>
                }
            </Grid2>
        </div>
    </>
}
